export class FamilySharingHelper {
    static normalizeEmail(email) {
        return String(email !== null && email !== void 0 ? email : "").trim().toLowerCase();
    }
    static mapEmails(users) {
        if (!Array.isArray(users)) {
            return [];
        }
        return users
            .map((user) => FamilySharingHelper.normalizeEmail(typeof user === "string" ? user : user === null || user === void 0 ? void 0 : user.email))
            .filter((email) => email.length > 0);
    }
    static isSelfEmail(email, userEmail) {
        const normalizedUserEmail = FamilySharingHelper.normalizeEmail(userEmail);
        return normalizedUserEmail.length > 0 && FamilySharingHelper.normalizeEmail(email) === normalizedUserEmail;
    }
    static isAlreadyInvited(email, invitedEmails, registeredEmails) {
        const normalizedEmail = FamilySharingHelper.normalizeEmail(email);
        return invitedEmails.includes(normalizedEmail) || registeredEmails.includes(normalizedEmail);
    }
}
